/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "@/api/axios";
import { ProjectDetail } from "@/features/user-profile/company-profile/services/company-details";

export type MapStyle = "automatic" | "satellite" | "street" | "outdoor";

export interface PinDescription {
  title: string;
  rows: {
    subTitle: string;
    pin_color: string;
  }[];
}

export interface MarkerType {
  _id: string;
  latitude: number;
  longitude: number;
  serviceType: string[];
  type: string;
}
export type TypeMapPins = Array<MarkerType>;

const initialMap = {
  mapState: {
    longitude: -122.59,
    latitude: 49.08,
    zoom: 10.6,
    pitch: 20,
    bearing: 0,
    speed: 1.2,
    popupAnchor: "bottom" as "top" | "bottom" | "left" | "right", // Default anchor
    popupOffset: [0, -20] as [number, number], // Default offset
  },
  mapStyle: "automatic" as MapStyle,
  selectedMarker: null as MarkerType | null,
  markerProjectDetails: [] as ProjectDetail[] | null,
  //   projects: [] as Array<MarkerType>,
  //   leads: [] as Array<ProjectDetail>,
  //   lead_ids: [] as Array<number>,
  page: 1,
  nextPage: NaN,
  limit: 20,
  totalCount: NaN,
  //   selectedLeadIds: [] as Array<number>,
  companyProfileFilters: {} as Record<string, (string | number)[]>,
  shareProfileFilters: {} as Record<string, (string | number)[]>,
  mapPins: [] as TypeMapPins,
  userCords: {} as { latitude: number; longitude: number },
  pinDescription: {} as PinDescription,
};

export type PARAMS_GET_PROJECT_LEADS = {
  page: number;
  limit: number;
  view: "map" | "list";
  sortBy: string;
  sortOrder: "asc" | "desc";
};

export const getMapPins = createAsyncThunk(
  "project_map/getMapPins",
  async ({
    params,
    body,
  }: {
    params: Partial<PARAMS_GET_PROJECT_LEADS>;
    body: object;
  }) => {
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/companyProfile/projects/pins/fetch",
        params: params,
        data: body,
      });

      console.log("response", response);

      const data = response.data.data as {
        currentPage: number;
        limit: number;
        nextPage: number;
        projects: MarkerType[];
        totalCount: number;
        pinDescription: PinDescription;
      };

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getPinDetails = createAsyncThunk(
  "project_map/getPinDetails",
  async ({ params }: { params: { projectId: string; type: string } }) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/companyProfile/projects/pins/details",
        params: params,
      });

      console.log("response", response);

      const data = response.data.data as ProjectDetail;

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getPublicMapPins = createAsyncThunk(
  "project_map/getPublicMapPins",
  async ({
    params,
    body,
  }: {
    params: Partial<PARAMS_GET_PROJECT_LEADS>;
    body: object;
  }) => {
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/companyProfile/projects/pins/fetch/public",
        params: params,
        data: body,
      });

      console.log("response", response);

      const data = response.data.data as {
        currentPage: number;
        limit: number;
        nextPage: number;
        projects: MarkerType[];
        totalCount: number;
        pinDescription: PinDescription;
      };

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getPublicPinDetails = createAsyncThunk(
  "project_map/getPublicPinDetails",
  async ({
    params,
  }: {
    params: { projectId: string; type: string; seo: string };
  }) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/companyProfile/projects/pins/details/public",
        params: params,
      });

      console.log("response", response);

      const data = response.data.data as ProjectDetail;

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

const shareMapSlice = createSlice({
  name: "project_map",
  initialState: initialMap,
  reducers: {
    setMapState: (state, action) => {
      state.mapState = {
        ...state.mapState,
        ...action.payload,
        latitude: action.payload.latitude ?? state.mapState.latitude, //  Agar latitude nahi mila toh purana use karo
        longitude: action.payload.longitude ?? state.mapState.longitude, //  Agar longitude nahi mila toh purana use karo
      };
    },
    setMapStyle: (state, action) => {
      state.mapStyle = action.payload;
    },
    setSelectedMarker: (state, action) => {
      state.selectedMarker = action.payload;
    },
    setPinDetails: (state, action) => {
      state.markerProjectDetails = action.payload;
    },
    setCompanyProfileFilters: (state, action) => {
      state.companyProfileFilters = action.payload;
    },
    setShareProfileFilters: (state, action) => {
      state.shareProfileFilters = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setNextPage: (state, action) => {
      state.nextPage = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setUserCords: (state, action) => {
      state.userCords = action.payload;
    },
    setPinDescription: (state, action) => {
      state.pinDescription = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMapPins.fulfilled, (state, action) => {
        if (action.payload) {
          state.mapPins = action.payload?.projects;
          if (action.payload?.pinDescription) {
            console.log("set pinDescription", action.payload.pinDescription);
            state.pinDescription = action.payload.pinDescription;
          }
        }
      })
      .addCase(getPinDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.markerProjectDetails = [action.payload];
        }
      })
      .addCase(getPublicMapPins.fulfilled, (state, action) => {
        if (action.payload) {
          state.mapPins = action.payload?.projects;
          if (action.payload?.pinDescription) {
            console.log("set pinDescription", action.payload.pinDescription);
            state.pinDescription = action.payload.pinDescription;
          }
        }
      })
      .addCase(getPublicPinDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.markerProjectDetails = [action.payload];
        }
      });
  },
});

export const {
  setMapState,
  setMapStyle,
  setSelectedMarker,
  setPage,
  setLimit,
  setPinDetails,
  setUserCords,
  setCompanyProfileFilters,
  setShareProfileFilters,
} = shareMapSlice.actions;
export default shareMapSlice.reducer;
